(function(angular){
	'use strict';
	
	var settingsNavObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			selectedInvestmentEntityId: '@',
			selectedInvestmentEntityLabel: '@',
			selectedInvestmentEntityUrlPath: '@',
			includeInvestmentPlan: '<',
			hasIraAccount: '<',
			currentTab: '@'
		},
		controller: [
			'$filter',
			'urlFactory',
			SettingsNavFunction
		],
		controllerAs: 'settingsNav'
	};
	
	angular
		.module('settingsModule')
		.component('settingsNav', settingsNavObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/settings/settings-nav.html';
	}
	
	function SettingsNavFunction(
		$filter,
		urlFactory
	){
		var settingsNav = this;
		var personalLabel;

		function initializeLinks() {
			switch(settingsNav.selectedInvestmentEntityLabel) {
				case 'Individual':
					personalLabel = 'Personal Information';
				break;
				case 'Joint Account':
					personalLabel = 'Account Information';
				break;
				case 'Trust':
					personalLabel = 'Trust Information';
				break;
				case 'Investment Company':
					personalLabel = 'Entity Information';
				break;
				case 'Individual Retirement Account':
					personalLabel = 'IRA Information';
				break;
			}

			var baseOptions = [
				{
					label: personalLabel,
					value: '/account/investment-accounts/personal-information'
				},{
					label: 'Account Settings',
					value: '/account/investment-accounts'
				},{
					label: 'Investment Plan',
					value: '/account/investment-accounts/' + settingsNav.selectedInvestmentEntityId + '/' + settingsNav.selectedInvestmentEntityUrlPath + '/investment-goal/manage',
					child: true
				},{
					label: 'Dividend Reinvestment',
					value: '/account/investment-accounts/' + settingsNav.selectedInvestmentEntityId + '/' + settingsNav.selectedInvestmentEntityUrlPath + '/ria-dividend-reinvestment/manage',
					child: true
				},{
					label: 'Auto-Invest',
					value: settingsNav.autoInvestPath,
					child: true
				},{
					label: 'Bank Accounts',
					value: '/account/investment-accounts/' + settingsNav.selectedInvestmentEntityId + '/' + settingsNav.selectedInvestmentEntityUrlPath + '/bank-accounts/manage',
					child: true
				},{
					label: 'Advanced Options',
					value: '/account/investment-accounts/' + settingsNav.selectedInvestmentEntityId + '/' + settingsNav.selectedInvestmentEntityUrlPath + '/advanced-options/manage',
					child: true
				},{
					label: 'Notifications',
					value: '/account/notifications/edit'
				},{
					label: 'Investor Profile',
					value: '/account/investor-profile/edit'
				},{
					label: 'Email Address',
					value: '/account/email/form'
				},{
					label: 'Security',
					value: '/account/security/manage'
				},{
					label: 'Password',
					value: '/account/security/manage-password',
					child: true
				},{
					label: 'Two-Factor Authentication',
					value: '/account/security/two-factor-authentication/manage',
					child: true
				},{
					label: 'Your Devices',
					value: '/account/security/your-devices/manage',
					child: true
				}
			];

			if(!settingsNav.dripEligibility) {
				baseOptions = $filter('omit')(baseOptions, function(opt) {
					return opt.label === 'Dividend Reinvestment';
				});
			}

			if(!settingsNav.recurringInvestmentEligibility) {
				baseOptions = $filter('omit')(baseOptions, function(opt) {
					return opt.label === 'Auto-Invest';
				});
			}

			if(!settingsNav.includeInvestmentPlan) {
				baseOptions = $filter('omit')(baseOptions, function(opt) {
					return opt.label === 'Investment Plan';
				});
			}

			if(settingsNav.selectedInvestmentEntityLabel === 'Individual Retirement Account') {
				baseOptions = $filter('omit')(baseOptions, function(opt) {
					return opt.label === 'Bank Accounts';
				});

			}

			settingsNav.linkOptions = baseOptions;
			formatMobileLinks();
			setCurrentLink();
		}

		function formatMobileLinks() {
			settingsNav.mobileLinkOptions = angular.copy(settingsNav.linkOptions);
			angular.forEach(settingsNav.mobileLinkOptions, function(mobileOption) {
				if(mobileOption.child) {
					mobileOption.label = '- ' + mobileOption.label;
				}
			});
		}

		function setCurrentLink() {
			var activeTab = (settingsNav.currentTab === 'Personal Information' ? personalLabel : settingsNav.currentTab);
			
			settingsNav.currentPage = $filter('filter')(settingsNav.linkOptions, {label: activeTab})[0];
			settingsNav.currentMobilePage = $filter('filter')(settingsNav.mobileLinkOptions, {value: settingsNav.currentPage.value}, true)[0];
		}
		
		settingsNav.newAccountRedirect = function() {
			if (settingsNav.newAccount !== 'Select') {
				urlFactory.redirect(settingsNav.newAccount);
			}
		};

		settingsNav.redirect = function(selectedLink) {
			if(selectedLink.value) {
				urlFactory.redirect(selectedLink.value);
			} else {
				settingsNav.currentMobilePage = $filter('filter')(settingsNav.mobileLinkOptions, {value: selectedLink}, true)[0];
				urlFactory.redirect(selectedLink);
			}
		};

		settingsNav.$onInit = function() {
			settingsNav.createAccountOptions = [{
				label: 'Entity Account',
				value: '/account/investment-accounts/new/entity-account/create'
			},{
				label: 'Joint Account',
				value: '/account/investment-accounts/new/joint-account/create'
			},{
				label: 'Trust Account',
				value: '/account/investment-accounts/new/trust/create'
			}];

			if(!settingsNav.hasIraAccount) {
				settingsNav.createAccountOptions.push({
					label: 'IRA Account',
					value: '/ira-onboarding/status'
				});
			}

			settingsNav.createAccountOptionsMobile = angular.copy(settingsNav.createAccountOptions);
			settingsNav.createAccountOptionsMobile.unshift({
				label: 'Select Account Type',
				value: 'Select'
			});
			settingsNav.createAccountMobileLink = settingsNav.createAccountOptionsMobile[0];

			urlFactory.apiGetPromise('/api-secured/investment-entities/overview')
				.then(function(response) {
					var existingAutoInvestLink = '/account/investment-accounts/'+ settingsNav.selectedInvestmentEntityId + '/' + settingsNav.selectedInvestmentEntityUrlPath + '/recurring-investment-settings/view';
					var newAutoInvestLink = '/account/recurring-investment/new?backLink=settings';

					var selectedInvestmentEntity = $filter('filter')(response.data.investmentEntities, {investmentEntityId: settingsNav.selectedInvestmentEntityId}, true)[0];

					settingsNav.recurringInvestmentEligibility = selectedInvestmentEntity.eligibleForRecurringInvestment;
					settingsNav.dripEligibility = selectedInvestmentEntity.eligibleForDrip;
					settingsNav.autoInvestPath = selectedInvestmentEntity.hasActiveRecurringInvestmentSchedule ? existingAutoInvestLink : newAutoInvestLink;

					initializeLinks();
					settingsNav.loaded = true;
				});

		};
	}
})(window.angular);